export const CQuestionsAndAnswersFragments = {
  field: `
    fragment questionsAndAnswers on questionsAndAnswers_MatrixField {
      ... on questionsAndAnswers_block_Entry {
        id
        typeHandle
        idName
        heading
        questions {
          question
          answer
        }
      }
    }
  `,
}
